import script from "./CategoriesView.vue?vue&type=script&lang=ts&setup=true"
export * from "./CategoriesView.vue?vue&type=script&lang=ts&setup=true"

import "./CategoriesView.vue?vue&type=style&index=0&id=fee8addc&lang=scss"

const __exports__ = script;

export default __exports__